export default "__VITE_ASSET__CmGnCB_M__"